import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEaComponent } from './simple-icons-ea.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEaComponent ],
    exports:      [ SimpleIconsEaComponent ],
    bootstrap:    []
})
export class SimpleIconsEaModule {}
